
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création de site Internet : comment choisir son CMS ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous venez de lancer votre nouvelle activité. Vous avez ainsi opté pour la création d’un site Internet clé en main afin de présenter vos produits et de communiquer auprès de vos clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création de site Internet : comment choisir son CMS ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous venez de lancer votre nouvelle activité. Vous avez ainsi opté pour la création d’un site Internet clé en main afin de présenter vos produits et de communiquer auprès de vos clients.",
        },
      ],
    };
  },
};
